import { ErrorBoundary as ReactErrorBoundary, type FallbackProps } from 'react-error-boundary'
import type { ReactNode } from 'react'
import { Button, Card } from './ui'

function Fallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <Card className="border-danger/40">
      <p className="mb-2 font-bold text-[#ff8d9a]">Algo falló en esta sección.</p>
      <p className="mb-3 text-sm text-muted">{error instanceof Error ? error.message : String(error)}</p>
      <Button variant="secondary" onClick={resetErrorBoundary}>
        Reintentar
      </Button>
    </Card>
  )
}

export function SectionErrorBoundary({ children }: { children: ReactNode }) {
  return <ReactErrorBoundary FallbackComponent={Fallback}>{children}</ReactErrorBoundary>
}
